import { styled, Breakpoints } from '@vw-marketing/us-components';

export const StyledTwitterCarouselContainer: any = styled.div`
  padding: 30px;
  padding-top: 0;
  overflow-x: hidden;
  @media (min-width: ${Breakpoints.b960}px) {
    padding: ${(props: any) => `0 ${props.theme.size.grid002}`};
  }
`;

export const StyledCarouselWrapper = styled.div`
  display: grid;
`;
